import React, { Component } from "react";
import propTypes from "prop-types";
import { withRouter } from "react-router-dom";

class Auth extends Component {
  static propTypes = {
    renderWidgetBlock: propTypes.func.isRequired,
    getWidgetText: propTypes.func.isRequired
  };

  state = {
    username: "",
    password: "",
    errors: {}
  };

  setError(name, message) {
    this.addErrors({ [name]: message });
  }

  getError(name) {
    return this.state.errors[name] || null;
  }

  addErrors(errors) {
    this.setState({ errors: { ...this.state.errors, ...errors } });
  }

  validate(attributes = null, refresh = true) {
    const errors = refresh ? {} : this.state.errors;
    const { username, password } = this.state;
    if (attributes && !Array.isArray(attributes)) {
      attributes = [attributes];
    }
    if ((!attributes || attributes.includes("username")) && !username) {
      errors["username"] = "Field 'login' is required";
    }
    if ((!attributes || attributes.includes("password")) && !password) {
      errors["password"] = "Field 'password' is required";
    }

    !attributes
      ? this.setState({ errors })
      : this.addErrors(
          attributes.reduce(
            (prev, attribute) =>
              Object.assign(prev, { [attribute]: errors[attribute] || null }),
            {}
          )
        );
    return !Object.entries(errors).length;
  }

  hasErrors(name = null) {
    const { errors } = this.state;
    return !!(name ? errors[name] : Object.entries(errors).length);
  }

  onSubmit = e => {
    if (!this.validate()) {
      e.preventDefault();
    }
  };

  onInputChange = (name, value) => {
    this.setState({ [name]: value }, () => {
      this.validate(name);
    });
  };

  render() {
    const { getWidgetText: getText, renderWidgetBlock: getBlock } = this.props;
    const {
      location: { pathname, search }
    } = this.props.history;
    const { REACT_APP_AUTH_HOST, REACT_APP_DOMAIN } = process.env;
    const authUrl =
      REACT_APP_AUTH_HOST +
      "/auth?redirect-url=//" +
      encodeURIComponent(REACT_APP_DOMAIN + pathname + search);
    return (
      <div className="login-wrapper">
        <div className="container">
          <div className="logo">
            <img src="/images/logo.png" alt="" />
          </div>
          <div className="login-body">
            <div className="about-block">
              {getBlock("div", "frontend.home.notAuthorized.h1")}
              {getBlock("div", "frontend.home.notAuthorized.h2")}
              {getBlock("ul", "frontend.home.notAuthorized.ul", {
                className: "advantages"
              })}
              {getBlock(
                "div",
                "frontend.home.notAuthorized.watchThePresentation",
                { className: "watchPresentation" }
              )}
            </div>
            <form
              className="login-block"
              method="POST"
              action={authUrl}
              onSubmit={this.onSubmit}
            >
              {getBlock("div", "frontend.home.notAuthorized.loginFormHeader", {
                className: "label-form"
              })}
              <input
                type="text"
                name="AuthForm[username]"
                className={
                  "login-input" +
                  ((this.hasErrors("username") && " has-error") || "")
                }
                placeholder="Логин"
                onChange={e => this.onInputChange("username", e.target.value)}
                value={this.state.username}
              />
              <input
                type="password"
                name="AuthForm[password]"
                className={
                  "login-input" +
                  ((this.hasErrors("password") && " has-error") || "")
                }
                placeholder="Пароль"
                onChange={e => this.onInputChange("password", e.target.value)}
                value={this.state.password}
              />
              <input
                type="submit"
                className="login-submit"
                value={getText("frontend.home.notAuthorized.loginFormButton")}
              />
              <div className="form-bottom">
                <div className="renderCheckBox">
                  <input
                    style={{ display: "none" }}
                    id="rememberme"
                    type="checkbox"
                    name="AuthForm[rememberMe]"
                    value="1"
                  />
                  <label htmlFor="rememberme" className="check">
                    <svg width="18px" height="18px" viewBox="0 0 18 18">
                      <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                      <polyline points="1 9 7 14 15 4" />
                    </svg>
                    &nbsp;Сохранить пароль
                  </label>
                </div>
                <a href="" className="link">
                  Забыли пароль?
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Auth);



// WEBPACK FOOTER //
// ./src/containers/main/auth.jsx